module.exports = __webpack_public_path__ + "static/media/chatHomePage.96f7f394.svg";